import {gql} from '@apollo/client';

export const activityMutations = {
    CREATE_ACTIVITY: gql`
        mutation createActivity($input: ActivityInputModelInput!, $objectId: UUID!, $objectType: String!) {
            createActivity(input: $input, objectId: $objectId, objectType: $objectType) {
                id
                user
                userId
                activityDate
                description
                objectId
                data
                objectType
                activityType
            }
        }
    `,
    UPDATE_ACTIVITY: gql`
        mutation updateActivity($input: ActivityUpdateModelInput!) {
            updateActivity(input: $input) {
                id
                user
                userId
                activityDate
                description
                objectId
                data
                objectType
                activityType
            }
        }
    `,
    REMOVE_ACTIVTIES_BY_IDS: gql`
        mutation removeActivitiesByIds($ids: [UUID!]!) {
            removeActivitiesByIds(ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_ACTIVITIES_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        mutation removeActivitiesByObjectIdAndObjectType($objectId: UUID!, $objectType: String!) {
            removeActivitiesByObjectIdAndObjectType(objectId: $objectId, objectType: $objectType) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
